
var Modal = require('ffss/ui/Modal');

class BtnExportExecutor{

    defaultOptions() {
        return {
            '$btn': null,
			'tickFrequency': 2000,
			'searchParameters': {},
			'exportParameters': null,
            'title': "Export",
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClick = this.onClick.bind(this);

        this.$btn = this.settings.$btn;
        if(!this.$btn){
            console.error("Btn is mandatory for BtnExportExecutor");
        }


        this.urlRequest = this.$btn.data('url-request');
        this.baseUrlStatus = this.$btn.data('url-status');
        this.baseUrlDownload = this.$btn.data('url-download');

        this.tickFrequency = this.settings.tickFrequency;
        if(this.$btn.data('tick-frequency')){
            this.tickFrequency = this.$btn.data('tick-frequency');
        }
        this.searchParameters = this.settings.searchParameters;
        if(this.$btn.data('search-parameters')){
            this.searchParameters = this.$btn.data('search-parameters');
        }
        this.exportParameters = this.settings.exportParameters;
        if(this.$btn.data('export-parameters')){
            this.exportParameters = this.$btn.data('export-parameters');
        }
        this.title = this.settings.title;
        if(this.$btn.data('modal-title')){
            this.title = this.$btn.data('modal-title');
        }

        this.initialize();
    }

	initialize(){
		var self = this;

        this.$btn.on('click',this.onClick);
    }

    onClick(event){
        event.preventDefault();
        event.stopPropagation();

		this.$modalMessage = $('<div/>')
		.addClass('alert alert-info export-message')
		.append("Veuillez patienter")
        .hide();

		this.$modalProgressBar =$('<div/>')
		.append(
			$('<div/>')
			.addClass('d-flex justify-content-center export-progressbar')
			.append(
				$('<i/>')
				.addClass('fa fa-spin fa-spinner fa-2x')
			)
		);

		this.$modalContent = $('<div/>')
		.addClass('export-modal-content')
		.append(this.$modalMessage)
		.append(this.$modalProgressBar);

        this.modal = new Modal({
            'modalId': 'exportModal',
			'title': this.title,
            'content' : this.$modalContent,
        })


        this.modal.show();

        this.launchExport();
    }

    launchExport(){
        var self = this;
		var requestData = {
			'searchParameters': this.searchParameters,
			'exportParameters': this.exportParameters
		};
		
		$.ajax({
			'url': this.urlRequest,
			'method': 'POST',
			'data': requestData
		})
		.done(function(xhr){
			if(xhr.success){
				self.onTick(xhr.data);
			}else{
				self.$modalMessage
				.removeClass('alert-info')
				.addClass('alert-danger')
				.html('Erreur : '+xhr.message);
				self.$modalProgressBar.html('');
			}
		})
		.fail(function(){
			self.$modalMessage
			.removeClass('alert-info')
			.addClass('alert-danger')
			.html('Erreur : Une erreur est advenue lors de la tentative de génération de l\'export');
			self.$modalProgressBar.html('');
		})
		.always(function(){

		});
    }
    
	onTick(data){
		var self = this;

		var id = data.id;
		var urlStatus = this.baseUrlStatus.replace('__ID__',id);

		$.ajax({
			url: urlStatus,
			method: 'GET'
		})
		.done(function(xhr){
			if(xhr.success){
				var data = xhr.data;
				//status => pending,processing,succeed,failed
				if(data.status == 'succeed'){
					self.showDownload(data);
				}else if(data.status == 'failed'){
					self.$modalMessage
					.removeClass('alert-info')
					.addClass('alert-danger')
					.html('Erreur : ' + data.message)
                    .show();
					self.$modalProgressBar.html('');
				}else{
					self.$modalMessage
                    .html(data.message)
                    .show();
					self.$modalProgressBar
					.html('')
					.append(self.makeProgressBar(data.progress));

					setTimeout(
						function(){
							self.onTick(data);
						},
						self.tickFrequency
					);
				}
			}else{
				self.$modalMessage
				.removeClass('alert-info')
				.addClass('alert-danger')
				.html('Erreur : '+xhr.message);
				self.$modalProgressBar.html('');
			}
		})
		.fail(function(){
			self.$modalMessage
			.removeClass('alert-info')
			.addClass('alert-danger')
			.html('Erreur : Une erreur est advenue lors de la tentative de génération de l\'export');
			self.$modalProgressBar.html('');
		})
		.always(function(){

		});
	}
    
	showDownload(data){
		var self = this;

		var id = data.id;
		var urlDownload = this.baseUrlDownload.replace('__ID__',id);


		$('.modal-dialog',this.$modal).removeClass('modal-lg');

		var $btnDownload = $('<a download/>')
		.addClass('btn btn-primary btn-icon')
		.attr('href',urlDownload)
		.append('<i class="icon icon-download me-2"></i> Télécharger le fichier')

		this.$modalMessage.hide();

		this.$modalProgressBar
		.addClass('d-flex justify-content-center')
		.html('')
		.append($btnDownload);
	}

	makeProgressBar(progress){
		var progressValue = Math.round(progress);
		var $html = $('<div/>')
		.addClass('progress')
		.append(
			$('<div/>')
			.css('width',progressValue+'%')
			.attr('role','progressbar')
			.attr('aria-valuenow',progressValue)
			.attr('aria-valuemin',0)
			.attr('aria-valuemax',100)
			.addClass('progress-bar progress-bar-striped')
		);


		return $html;
	}
}

module.exports = BtnExportExecutor;